<template>
  <div class="header-area bg-color-faf4f4">
    <div class="container-fluid mw-1740">
      <div class="d-flex justify-content-between top-header-content">
        <div class="d-flex align-items-center">
          <img src="../../assets/images/email.png" alt="email" />
          <div class="ms-2">
            <span>Email us</span>
            <a title="MyCelebrity by Digitalentio is a leading celebrity and influencer marketing agency in India." href="mailto:support@adli.com">info@mycelebrity.in</a>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/phone.png" alt="phone" />
          <div class="ms-2">
            <span>Call us</span>
            <a  title="MyCelebrity by Digitalentio is a leading celebrity and influencer marketing agency in India." href="tel:+1-485-456-0102">+91-9986516463</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopHeader",
};
</script>

<style lang="scss" scoped>
.top-header-content {
  padding: 12.5px 0;

  img {
    position: relative;
    top: -1px;
  }
  span {
    font-size: 13px;
    color: #4c4c4c;
    display: block;
    line-height: 1;
    margin-bottom: -3px;
  }
  a {
    font-size: 14px;
    font-weight: 600;
    color: var(--headingColor);
    line-height: 1;
    text-decoration: none;
    &:hover {
      color: var(--mainColor);
    }
  }
}

/* Max width 767px */
@media only screen and (max-width: 767px) {
  .top-header-content {
    a {
      font-size: 13px;
    }
  }
}
</style>